import { useWebSocket } from '@vueuse/core'

export default defineNuxtPlugin(() => {
  // Create reactive status outside of wsRef
  const connectionStatus = ref('CLOSED')
  let wsRef: ReturnType<typeof useWebSocket> | null = null

  function connect() {
    // Só inicializa uma vez
    if (wsRef)
      return

    const chatserver = isLocalhost ? 'wss://localhost:8000' : `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.hostname}`
    console.log('chat', chatserver)
    const { status, send, data, open, close } = useWebSocket(`${chatserver}/chat/ws/${useAuthStore().user?.id}`, {
      autoReconnect: { retries: 3, delay: 3000 }
    })

    watch(() => status.value, (value) => {
      connectionStatus.value = value // Update our reactive status
      console.log('status', value)
    })

    wsRef = { status, send, data, open, close, ws: null }
  }

  return {
    provide: {
      ws: {
        connect,
        get status() { return connectionStatus },
        get data() { return wsRef?.data },
        get active() { return connectionStatus.value?.toLowerCase() === 'open' },
        send(payload: any) {
          wsRef?.send(payload)
        },
        close() {
          wsRef?.close()
          wsRef = null
          connectionStatus.value = 'CLOSED'
        },
        get wsRef() { return wsRef }
      }
    }
  }
})
